const STORAGE_NS = "report_template_pref_v1";
const DEFAULT_TEMPLATE_ID = "ud1000-convergence-report";
const ALLOWED_TEMPLATE_IDS = [
  "ud1000-convergence-report",
  "electrical-duty-report",
  "equipment-timeseries-report",
];

function isBrowser() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

function keyOf(userId) {
  if (!userId) return null;
  return `${STORAGE_NS}:${userId}`;
}

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function normalizeTemplateId(templateId) {
  return ALLOWED_TEMPLATE_IDS.includes(templateId)
    ? templateId
    : DEFAULT_TEMPLATE_ID;
}

export function getReportTemplatePref(userId) {
  if (!isBrowser()) return DEFAULT_TEMPLATE_ID;

  const storageKey = keyOf(userId);
  if (!storageKey) return DEFAULT_TEMPLATE_ID;

  const raw = localStorage.getItem(storageKey);
  if (!raw) return DEFAULT_TEMPLATE_ID;

  const parsed = safeParse(raw);
  if (!parsed || parsed.v !== 1) return DEFAULT_TEMPLATE_ID;

  return normalizeTemplateId(parsed.templateId);
}

export function setReportTemplatePref(userId, templateId) {
  if (!isBrowser()) return;

  const storageKey = keyOf(userId);
  if (!storageKey) return;

  const payload = {
    v: 1,
    t: Date.now(),
    templateId: normalizeTemplateId(templateId),
  };

  localStorage.setItem(storageKey, JSON.stringify(payload));
}

export const REPORT_TEMPLATE_PREF = {
  DEFAULT_TEMPLATE_ID,
  ALLOWED_TEMPLATE_IDS,
};
